import { fork } from 'redux-saga/effects';

import loginFacebook from './facebook';
import sendPhone from './sendPhone';
import sendPinCode from './sendPinCode';
import register from './register';
import modify from './modify';
import loginEmail from './loginEmail';
import user from './user';

export default function* ssoSaga() {
  yield fork(loginFacebook);
  yield fork(sendPhone);
  yield fork(sendPinCode);
  yield fork(loginEmail);
  yield fork(register);
  yield fork(modify);
  yield fork(user);
}
